// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ssz_","title":"Info_title__2frj4","selects":"Info_selects__2P0Ty","requiredAsterisk":"Info_requiredAsterisk__3X4b1"};